import CloseIcon from "@mui/icons-material/Close";
import { Alert, Collapse, IconButton, Stack } from "@mui/material";
import ErrorIcon from "assets/images/warning-2.svg";
import WarningIcon from "assets/images/WarningAmberOutlined.svg";
import { CircularLoaderFullPage } from "components/core";
import DownloadPopup from "components/core/modal-components/DownloadPopup";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CF_URLS } from "services/api/endpoints";
import { selectAuth } from "store/slices";
import spacing from "styles/spacing";
import {
  downloadOptionPdf,
  ERROR_TYPES,
  VALUE_EMPTY_STRING
} from "utils/constants";
import {
  operationalModeId,
  printPdfLabel,
  severityError
} from "utils/constants/discrepancy-management/DiscrepancyUpdate";
import {
  dataDogErrorLog,
  findErrorMessage,
  getUserName,
  handleRefId,
  printReport
} from "utils/helpers";
import AuthForm from "./AuthForm";
import DiscrepancyUpdate from "./DiscrepancyUpdate";
import { DetailsStyles } from "./Styles";

const DiscrepancyUpdateLayout = () => {
  const { showAuthSection, isAuthenticated } = useSelector(
    (state) => state.discrepancyUpdate
  );
  const [isLoading, setIsLoading] = useState(false);
  const [throwErrorMessage, setThrowErrorMessage] = useState(null);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [severity] = useState(severityError);
  const [printData, setPrintData] = useState(null);
  const [reportCUrl, setReportCFUrl] = useState(VALUE_EMPTY_STRING);
  const [selectedValue, setSelectedValue] = useState(downloadOptionPdf);
  const { currentBranch, auth } = useSelector(selectAuth);
  useEffect(() => {
    if (throwErrorMessage) {
      throwErrorMessage && window.scrollTo(0, 0);
    }

    //eslint-disable-next-line
  }, [throwErrorMessage]);

  const handlePrint = async () => {
    try {
      setIsLoading(true);
      const requestBody = JSON.stringify({
        main_district_id: currentBranch?.value,
        operational_mode_id: operationalModeId,
        user_name: getUserName(auth?.user),
        report_format: selectedValue?.type?.toUpperCase(),
        ...printData,
        ...printPdfLabel
      });
      const url = CF_URLS.printReports.discrepancy.additionalinformationreport;
      let reportResponse = await printReport(requestBody, url);
      if (!reportResponse?.success) {
        setThrowErrorMessage(reportResponse?.error);
      }
      setShowPrintModal(false);
      setIsLoading(false);
    } catch (e) {
      const { refId, message } = handleRefId(
        findErrorMessage(ERROR_TYPES.ISSUE)
      );
      dataDogErrorLog(message, "", { error: e }, refId);
      setThrowErrorMessage(message);
      setIsLoading(false);
      setShowPrintModal(false);
    }
  };
  return (
    <Stack gap={spacing.gap}>
      <CircularLoaderFullPage loading={isLoading} />
      <AuthForm setLoading={setIsLoading} />
      <DownloadPopup
        title={t("common.downloadReport")}
        showPrintModal={showPrintModal}
        onCancleClick={() => {
          setPrintData(null);
          setShowPrintModal(false);
          setReportCFUrl(VALUE_EMPTY_STRING);
        }}
        onDownloadClick={() => {
          handlePrint();
        }}
        cfUrl={reportCUrl}
        setSelectedValue={setSelectedValue}
      />
      {throwErrorMessage && (
        <Collapse in={!!throwErrorMessage}>
          <Alert
            severity={severity}
            sx={DetailsStyles.errorStyle}
            icon={
              <img
                src={severity === severityError ? ErrorIcon : WarningIcon}
                alt="error"
                style={DetailsStyles.iconStyle}
              />
            }
            action={
              <IconButton
                aria-label={t("common.close")}
                color="inherit"
                size="small"
                onClick={() => {
                  setThrowErrorMessage(null);
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {throwErrorMessage}
          </Alert>
        </Collapse>
      )}

      {(!showAuthSection || isAuthenticated) && (
        <DiscrepancyUpdate
          setIsLoading={setIsLoading}
          setThrowErrorMessage={setThrowErrorMessage}
          isLoading={isLoading}
          handlePrint={(value) => {
            setPrintData(value);
            setShowPrintModal(true);
            setReportCFUrl(
              CF_URLS.printReports.discrepancy.additionalinformationreport
            );
          }}
        />
      )}
    </Stack>
  );
};
export default DiscrepancyUpdateLayout;
